module.exports = __webpack_public_path__ + "img/icon_happiness_white.c8450721.svg";